import { render, staticRenderFns } from "./AttachmentsForm.vue?vue&type=template&id=43549c6f&"
import script from "./AttachmentsForm.vue?vue&type=script&lang=js&"
export * from "./AttachmentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports